export default function DashboardView() {
    return (
        <section>
            Dashboard admin
        </section>
    )
}